import React, { createContext } from 'react';
import { setInitialBannerCounters } from './helpers';

const BannerContext = createContext({});

const BannerContextProvider = ({ children, siblings, banners, pbOptions }) => {
  const bannerCounters = setInitialBannerCounters(banners);
  const bannerPositionCounter = { counter: 0 };
  const blockTracker = { lastBlockType: null };

  return (
    <BannerContext.Provider
      value={{
        banners,
        bannerCounters,
        bannerPositionCounter,
        siblings,
        pbOptions,
        blockTracker
      }}>
      {children}
    </BannerContext.Provider>
  );
};

export { BannerContext, BannerContextProvider };
